module.exports = __webpack_public_path__ + "static/media/trimex_silao.69a5a555.png";